module.exports = __webpack_public_path__ + "img/calendar.489e0971.svg";